// Tiny hook that fetches /api/settings once and returns hero overrides.
import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useHeroImages() {
  const [s, setS] = useState({});
  useEffect(() => {
    axios.get(`${API}/settings`).then((r) => setS(r.data || {})).catch(() => {});
  }, []);
  return {
    home: s.hero_home_image || '',
    homeVideo: s.hero_home_video || '',
    about: s.hero_about_image || '',
    strategy: s.hero_strategy_image || '',
    security: s.hero_security_image || '',
  };
}
